import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { userLink } from '../utils';

/**
 * Riquadro "Statistics" in fondo all'indice, come in phpBB: messaggi, argomenti, iscritti e ultimo iscritto.
 * I numeri sono quelli che vede un ospite (attributo runeaudioStats del forum, extend.php).
 */
export default class BoardStats extends Component {
  view() {
    const stats = app.forum.attribute('runeaudioStats');
    if (!stats) return null;
    const newest = stats.newestMember;
    return m("div", {
      className: "BoardStats"
    }, m("h3", null, "Statistics"), m("p", null, "Total posts ", m("strong", null, stats.posts), " \u2022 Total topics ", m("strong", null, stats.topics), " \u2022 Total members", ' ', m("strong", null, stats.members), newest && [' • Our newest member ', m("strong", null, userLink({
      id: () => newest.id,
      displayName: () => newest.username
    }))]));
  }
}
flarum.reg.add('runeaudio-theme', 'forum/components/BoardStats', BoardStats);